import React from 'react';

import { getEvenNumber } from '../utils/getters';

function Tags({ tags }) {
  return (
    <>
      {tags && (
        <div className="tags">
          {tags.map((tag, i) => (
            <p
              className={`body --x-small --margin-bottom-null ${
                !getEvenNumber(i) ? '' : '--highlighted'
              }`}
              key={tag.title || tag}
            >
              {tag.title || tag}
            </p>
          ))}
        </div>
      )}
    </>
  );
}

export default Tags;
